<template lang="pug">
  include ../mixins
  +b.lightbox-container(ref="wrapper")
    lightbox(
      :visible="visible",
      :imgs="source"
      :index="index"
      @hide="handleHide"
      ref="lightbox",
    )
    slot(name="image" :open='showImg')
    slot(:add='(event) => addListeners(event)')
</template>

<script>
import Masonry from 'masonry-layout'
import Lightbox from 'vue-easy-lightbox'

export default {
  name: 'ui-lightbox',
  components: {
    Lightbox,
  },
  props: {
    source: Array,
    isSlider: {
      type: Boolean,
      default: () => false,
    },
    isMasonry: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      index: 0,
      img: [],
    }
  },
  mounted() {
    if (false === this.isSlider) this.addListeners()

    this.initMasonry()
  },

  methods: {
    initMasonry() {
      if (this.isMasonry) {
        const { wrapper } = this.$refs

        // eslint-disable-next-line
        new Masonry(wrapper, {
          itemSelector: '.gallery-item',
          percentPosition: true,
        })
      }
    },

    addListeners(slick) {
      let items = []
      if (true === this.isSlider) {
        items = Array.from(
          slick.$list[0].getElementsByClassName('js-lightbox')
        )
      } else {
        items = Array.from(document.getElementsByClassName('js-lightbox'))
      }
      if (items) {
        items.forEach(el => {
          const index = el.dataset.img
          const self = this
          el.addEventListener('click', () => {
            self.showImg(Number(index))
          })
        })
      }
    },
    showImg(index) {
      this.visible = true
      this.index = index
      // this.toggleHeader('-1')
    },
    handleHide() {
      this.visible = false
      // this.toggleHeader('113')
    },
    // toggleHeader(value) {
    //   const [header] = document.getElementsByTagName('header')
    //   header.style.zIndex = value
    //   header.style.position = 'relative'
    // },
  },
}
</script>
